module.exports = __webpack_public_path__ + "static/HR Portal Meine Daten Kinder-36c511d01d6ca98ca1fc23e46eaf3697.jpg";